export const locale = {
  lang: 'nl',
  data: {
    'PERFIL_USUARIO': {
      'TITULO': 'Mijn profiel',
      'ENLACES': {
        'configuracion': 'Account instellingen',
        'notificaciones': 'Gebruikersmeldingen',
        'mensajes': 'Ontvangen berichten'
      },
      'PAGINAS': {
        'configuracion': {
          'TITULO': 'Account instellingen',
          'OPCIONES': {
            'CAMBIARMAIL': {
              'TITULO': 'E-mail wijzigen',
              'SUBTITULO': 'U kunt het e-mailadres van uw account wijzigen',
              'INPUTS': {
                'MAIL': 'nieuw e-mailadres',
                'TOKEN': 'Verificatie code',
                'PASS': 'nieuw paswoord',
                'CONFIRMPASS': 'bevestig wachtwoord'
              },
              'BOTONES': {
                'CAMBIAMAIL': 'E-mail wijzigen',
                'VERTOKEN': 'Controleer code',
                'FINALMAIL': 'E-mailadres wijzigen',
              }
            },
            'CAMBIARPASS': {
              'TITULO': 'Wachtwoord wijzigen',
              'SUBTITULO': 'U kunt uw accountwachtwoord wijzigen',
              'BOTONES': {
                'FINALPASS': 'Wachtwoord wijzigen'
              }
            },
            'AUTENTICACION': {
              'TITULO': 'Authenticatie in twee stappen',
              'SUBTITULO': 'U kunt de beveiliging van uw account verhogen door authenticatie in twee stappen te activeren',
              'BOTONES': {
                'ACTIVAR': 'Activeren',
                'DESACTIVAR': 'Deactiveren'
              }
            }
          }
        }
      },
      'MODALES': {
        'CAMBIARMAIL_PASO1_OK': 'Er is een bericht verzonden naar het opgegeven e-mailadres met een verificatiecode, voer de ontvangen verificatiecode in om door te gaan met het proces',
        'CAMBIARMAIL_PASO1_NOTOK': 'Kan niet doorgaan, het ingevoerde e-mailadres is al geregistreerd in het systeem',
        'CAMBIARMAIL_PASO1_SAME': 'Kan niet doorgaan, het ingevoerde e-mailadres is hetzelfde als het huidige account',
        'CAMBIARMAIL_PASO2_OK': 'De verificatiecode is correct, om verder te gaan, moet u hieronder een nieuw wachtwoord invoeren',
        'CAMBIARMAIL_PASO2_NOTOK': 'De verificatiecode is onjuist, controleer of u deze correct heeft ingevoerd en controleer deze opnieuw',
        'CAMBIARMAIL_PASO3_NOTOK': 'Kan niet doorgaan, wachtwoorden komen niet overeen, voer ze opnieuw correct in',
        'CAMBIARMAIL_PASO3_OK': 'De accountgegevens zijn correct bijgewerkt, om het proces te voltooien wordt de sessie gesloten, betreedt u het platform opnieuw met de nieuwe toegangsgegevens',
        'CAMBIAPASS_OK': 'Het accountwachtwoord is succesvol bijgewerkt',
        'CAMBIAPASS_NOTOK': 'Kan niet doorgaan, wachtwoorden komen niet overeen, voer ze opnieuw correct in',
        'AUTHOK': 'Verificatiestatus succesvol bijgewerkt'
      }
    },
    'PROFILE': {
      'MENU_TITLE':'Sluiten      ',
      'MYPROFILLE':'Mijn profiel',

      'TITLE': 'Wijzig wachtwoord',
       'BTNBACK': 'Terug',
       'MENUTITLE': 'Menu',
       'MENU':{
         'OPC1': 'Mijn gegevens'
       },
       'NAME': 'Naam',
       'EMAIL': 'E-mail',
       'CODE': 'Verificatiecode',
       'NEWPASS': 'Nieuw wachtwoord',
       'REPASS': 'Herhaal wachtwoord',
       'CHANGE': 'Wijziging van het wachtwoord',
       'SENDCODE': 'Verificatiecode verzenden',
       'CHECKCODE': 'Verifieer de code',
       'ERROR':{
        'ERROR01': 'Verplicht veld',
        'ERROR02': 'Fout, er is iets gebeurd',
        'ERROR03': 'De code komt niet overeen',
        'ERROR04': 'Wachtwoorden komen niet overeen',
        'ERROR05': 'Moet minimaal 3 karakters bevatten',
        'ERROR06': 'De e-mail bestaat al, probeer het met een andere',
        'ERROR07': 'Bedrijfsnaam komt niet overeen'
      },
      'SUCCESS':{
        'OK': 'Ok',
       'MESESAGE1': 'Gegevens correct bijgewerkt',
       'MESESAGE2':'Code verzonden ... Controleer uw e-mail',
       'MESESAGE3': 'Correcte code'
      }
    }
  }
};
